var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root"},[_c('div',{staticClass:"target",class:{ 'is-show': _vm.isShow }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }